import React from "react";
import { ColumnProps, RowDataType } from "rsuite-table";

import { Car } from "../../../../../services";
import LightTable from "../../../../LightTable";
import { TranslationText } from "../../../../common";

import columns, { ColumnId } from ".";

function base(
	columnId: ColumnId,
	render: base.Render,
	column: Partial<ColumnProps<RowDataType>>,
) {
	return (
		<LightTable.Column key={columnId} resizable sortable {...column}>
			<LightTable.HeaderCell>
				<TranslationText text={columns[columnId].label} />
			</LightTable.HeaderCell>
			<LightTable.Cell dataKey={columnId} fullText>
				{(rowData) => render(rowData as Car.Model)}
			</LightTable.Cell>
		</LightTable.Column>
	);
}

declare namespace base {
	type Render = (item: Car.Model) => React.ReactNode;
}

export default base;
